type List = {
  id: number;
  label: string;
};

export const uniqueList = (list: List[] | undefined) => (list === undefined ? []
  : list.filter((item, index, arr) => arr
    .findIndex((item2) => item.id === item2.id) === index));
